export enum CustomSentryMessage {
    BeforeUnload,
    CancellationDialogOpened,
    CancellationDialogStopMeasurement,
    CancellationDialogContinueMeasurement,
    MeasurementCompleted,
}

export default CustomSentryMessage;